import React from 'react';
import FormularioReclamo from '../layout/layout-reclamos/formulario-reclamo';
import { Seo } from 'core/components/seo';
import { useAppName } from 'legacyfrontend/hooks/useSafeState';

export default function Reclamos() {
  const appName = useAppName();

  return (
    <>
      <Seo
        title={`Reclamos | ${appName}`}
        description={`Realizá tu reclamo en ${appName}. Libro de quejas y reclamos para consumidores.`}
      />
      <FormularioReclamo />
    </>
  );
}
